import {
  provideRouter,
  Routes,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';

import { ContentComponent } from 'src/app/shared/components/layout/content/content.component';
import { loadPortalRoutes } from 'src/app/shared/routes/routes';
import { authRoutes } from './shared/auth/auth-routes';
import { downtimeRoutes } from './shared/components/downtime-redirect/downtime-routes';
import { messageRoutes } from './shared/components/message-errors/message-routes';
import { downtimeGuard } from './shared/guard/downtime.guard';

const navRoutes: Routes = [
  {
    path: 'downtime',
    children: downtimeRoutes,
  },
  {
    path: 'auth',
    canActivate: [downtimeGuard],
    children: authRoutes,
  },
  {
    path: 'nda-approval',
    canActivate: [downtimeGuard],
    loadComponent: () =>
      import('./portals/developer/nda/approval/nda-approval.component').then((m) => m.NdaApprovalComponent),
  },
  {
    path: '',
    component: ContentComponent,
    canActivate: [downtimeGuard],
    loadChildren: () => loadPortalRoutes(),
  },
  {
    path: 'message',
    children: messageRoutes,
  },
  {
    path: 'context/links',
    loadComponent: () =>
      import('./portals/merchant/link/app-store-link/app-store-link').then((m) => m.AppStoreLinkComponent),
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];

export const routingProvider = provideRouter(
  navRoutes,
  withComponentInputBinding(),
  withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
  withViewTransitions(),
);
